import axios from 'axios';

const FRIENDLY_MESSAGES = {
  FORBIDDEN: 'You do not have permission to view this information.',
  NOT_FOUND: 'The requested coupon information was not found.',
  BAD_REQUEST: 'The request was invalid. Please try again.',
  COUPON_EXPIRED: 'This coupon has expired.',
  COUPON_INACTIVE: 'This coupon is not active yet.',
  COUPON_EXHAUSTED: 'This coupon has no remaining balance.',
  TEST_ALREADY_USED: 'This test has already been used.',
  INSUFFICIENT_BALANCE: 'There is not enough balance remaining on this coupon.',
  NO_TOKEN: 'Your session is missing. Please log in again.',
  UNAUTHORIZED: 'Your session expired or is invalid. Please log in again.',
  TIMEOUT: 'The request timed out. Please try again.',
  NETWORK: 'Unable to reach the server. Please check your connection and try again.',
  UNKNOWN: 'Something went wrong. Please try again.',
};

export function isCouponRequestCancelled(error) {
  if (!error) return false;
  if (error.code === 'ERR_CANCELED') return true;
  return typeof axios.isCancel === 'function' && axios.isCancel(error);
}

export function normalizeCouponError(error) {
  if (isCouponRequestCancelled(error)) return null;

  const status = error?.response?.status ?? null;
  const data = error?.response?.data || {};
  const apiCode = typeof data.code === 'string' ? data.code : null;

  if (!error?.response && error?.code === 'NO_TOKEN') {
    return { code: 'NO_TOKEN', message: FRIENDLY_MESSAGES.NO_TOKEN, status: null };
  }

  if (status === 401) {
    return { code: 'UNAUTHORIZED', message: FRIENDLY_MESSAGES.UNAUTHORIZED, status: 401 };
  }

  if (apiCode && Object.prototype.hasOwnProperty.call(FRIENDLY_MESSAGES, apiCode)) {
    return { code: apiCode, message: FRIENDLY_MESSAGES[apiCode], status };
  }

  if (!error?.response && error?.code === 'ECONNABORTED') {
    return { code: 'TIMEOUT', message: FRIENDLY_MESSAGES.TIMEOUT, status: null };
  }

  if (!error?.response && (error?.request || error?.message === 'Network Error')) {
    return { code: 'NETWORK', message: FRIENDLY_MESSAGES.NETWORK, status: null };
  }

  return {
    code: apiCode || 'UNKNOWN',
    message:
      (typeof data.message === 'string' && data.message) ||
      (typeof error?.message === 'string' && error.message) ||
      FRIENDLY_MESSAGES.UNKNOWN,
    status,
  };
}

export default normalizeCouponError;
